<template>
  <Modal
    :id="'cmp-booking-booking_list-enable_online_agreemenet'"
    @cancelled="onModalCancelled"
  >
    <template slot="header">{{ $t("enable_online_agreement") }}</template>
    <template slot="body">
      <p>
        {{ $t("enable_online_agreement_question") }}
      </p>
      <div style="margin: 20px 0px" class="dt-list-v2">
        <div
          class="dt-list--item"
          v-for="(document, index) of documents"
          :key="index"
        >
          {{ documentDate(document) }} {{ document.booking_template_name }}
          {{ document.subject }}
        </div>
      </div>
      <p>
        {{ $t("enable_online_agreement_info") }}
      </p>
    </template>
    <template slot="options">
      <button class="dt-button s6 v1" @click="enableOA">{{ $t("yes") }}</button>
      <button class="dt-button s6" @click="displayOnly">
        {{ $t("no_display_only") }}
      </button>
      <button class="dt-button s6" @click="onModalCancelled()">
        {{ $t("cancel") }}
      </button></template
    >
  </Modal>
</template>
<script>
import Modal from "../../../dt-plugins/modal/modal";
import { documentDate } from "../models/document.model";

export default {
  components: {
    Modal,
  },
  props: ["documents"],
  methods: {
    documentDate: documentDate,
    onModalCancelled: function () {
      this.$emit("cancelled", true);
    },
    enableOA() {
      this.$emit("enableOA", true);
    },
    displayOnly() {
      this.$emit("displayOnly", true);
    },
  },
};
</script>